import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

export default function GoogleCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get("token");
    const role = params.get("role");
    const id = params.get("id");
    const approved = parseInt(params.get("approved"));

    if (!token || !role || !id) {
      navigate("/login"); // fallback
      return;
    }

    localStorage.setItem("token", token);
    localStorage.setItem("role", role);
    localStorage.setItem("id", id);
    localStorage.setItem("approved", approved);

    // redirect based on role + approval
    if (role === "employee") {
      if (approved === 0) {
        navigate("/professionals-approval");
      } else {
        navigate("/");
      }
    } else if (role === "company") {
      if (approved === 0) {
        navigate("/company-approval");
      } else if (approved === 1) {
        navigate("/company-under-review");
      } else {
        navigate("/");
      }
    }
  }, [params, navigate]);

  return <p>Logging you in via Google...</p>;
}
